import { render, staticRenderFns } from "./IconWorldNetwork.vue?vue&type=template&id=42a0a310&"
import script from "./IconWorldNetwork.vue?vue&type=script&lang=ts&"
export * from "./IconWorldNetwork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports